import script from "./QuickReplyOption.vue?vue&type=script&lang=ts&setup=true"
export * from "./QuickReplyOption.vue?vue&type=script&lang=ts&setup=true"

import "./QuickReplyOption.vue?vue&type=style&index=0&id=4db1fa3d&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4db1fa3d"]])

export default __exports__